import type { ComponentProps } from 'react';

import type { FieldLayoutOptions } from './useFieldLayout';
import { FormWeekPickerInput } from './FormField';
import { useFieldLayout } from './useFieldLayout';

type WeekPickerFieldProps = Omit<
  ComponentProps<typeof FormWeekPickerInput>,
  'label' | 'inputHeight' | 'inputBackground'
> &
  FieldLayoutOptions;

export const WeekPickerField = ({ label, hideLabel, ...fieldProps }: WeekPickerFieldProps) => {
  const field = useFieldLayout({ label, hideLabel });

  return (
    <FormWeekPickerInput
      label={field.label}
      inputHeight={field.inputHeight}
      inputBackground={field.inputBackground}
      {...fieldProps}
    />
  );
};
